import { Navigate } from 'react-router-dom';
import { useAuthContext } from '../../context/AuthContext';

const ProtectedRoute = ({ children }) => {
    const { currentUser } = useAuthContext();

    // The Bouncer Check: If there is no user, kick them to the login page!
    if (!currentUser) {
        // Note: 'replace' is a security feature. It overwrites their browser history
        // so they can't just hit the "Back" button to break back into the page!
        return <Navigate to="/login" replace />;
    }

    // They are logged in, so open the door and render the page
    return children;
};

export default ProtectedRoute;
